import React from 'react';
import Link from '../../components/ui/Link';
import { useTranslation } from 'react-i18next';

const NewArrivals = () => {

  const {t} = useTranslation();

  return (
    <section className="w-full py-8 lg:py-16">
      <div className="w-full max-w-[1262px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-8 lg:mb-11">
          <h2 className="text-2xl lg:text-4xl font-medium text-black">{t("newArrivals")}</h2>
        </div>

        {/* New Arrivals Grid */}
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          {/* PlayStation 5 - Large Card */}
          <div className="w-full lg:w-1/2">
            <div className="relative bg-black rounded-lg overflow-hidden p-6 lg:p-8 min-h-[400px] lg:min-h-[600px]">
              {/* PlayStation Image */}
              <div className="absolute bottom-8 right-8 lg:bottom-16 lg:right-16">
                <img
                  src="/images/img_ps5_slim_goedko.png"
                  alt="PlayStation 5 Console"
                  className="w-[300px] lg:w-[510px] h-auto object-contain"
                  loading="lazy"
                />
              </div>
              
              {/* Content */}
              <div className="relative z-10 flex flex-col justify-end h-full max-w-md">
                <div className="flex flex-col gap-3 lg:gap-4">
                  <h3 className="text-xl lg:text-3xl font-semibold text-[#f9f9f9]">
                    PlayStation 5
                  </h3>
                  <p className="text-sm text-[#f9f9f9] leading-relaxed">
                    Black and White version of the PS5 coming out on sale.
                  </p>
                  <div className="flex flex-col gap-1">
                    <Link 
                      href="/playstation-5" 
                      className="text-base font-semibold text-white hover:opacity-80 transition-opacity"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel=""
                      onClick={() => {}}
                      aria-label="Shop PlayStation 5"
                    >
                      Shop Now
                    </Link>
                    <img 
                      src="/images/img_underline.svg" 
                      alt="" 
                      className="w-[80px] h-[1px]"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Multiple Cards */}
          <div className="w-full lg:w-1/2 flex flex-col gap-6 lg:gap-8">
            {/* Women's Collections */}
            <div className="bg-[#0d0d0d] rounded-lg overflow-hidden p-4 lg:p-5 min-h-[200px] lg:min-h-[284px]">
              <div className="flex items-center h-full">
                <div className="flex-1 flex flex-col justify-center gap-3 lg:gap-4 pr-4">
                  <h3 className="text-xl lg:text-3xl font-semibold text-[#f9f9f9]">
                    Women's Collections
                  </h3>
                  <p className="text-sm text-[#f9f9f9] leading-relaxed">
                    Featured woman collections that give you another vibe.
                  </p>
                  <div className="flex flex-col gap-1">
                    <Link 
                      href="/women-collections" 
                      className="text-base font-semibold text-white hover:opacity-80 transition-opacity"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel=""
                      onClick={() => {}}
                      aria-label="Shop Women's Collections"
                    >
                      Shop Now
                    </Link>
                    <img 
                      src="/images/img_underline.svg" 
                      alt="" 
                      className="w-[80px] h-[1px]"
                    />
                  </div>
                </div>
                <div className="flex-shrink-0">
                  <img
                    src="/images/img_attractive_woma.png"
                    alt="Women's Fashion Collection"
                    className="w-[200px] lg:w-[432px] h-auto object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>

            {/* Bottom Row - Speakers and Perfume */}
            <div className="flex flex-col sm:flex-row gap-4 lg:gap-8">
              {/* Speakers */}
              <div className="flex-1 bg-black rounded-lg p-4 lg:p-6 min-h-[200px] lg:min-h-[284px] relative">
                {/* Background Circle */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[196px] h-[196px] bg-[#d9d9d9e5] rounded-full shadow-[0px_4px_300px_#888888ff] opacity-50"></div>
                
                {/* Speaker Image */}
                <div className="absolute top-4 left-1/2 transform -translate-x-1/2">
                  <img
                    src="/images/img_69_694768_amazo_220x190.png"
                    alt="Amazon Wireless Speakers"
                    className="w-[150px] lg:w-[190px] h-auto object-contain"
                    loading="lazy"
                  />
                </div>

                {/* Content */}
                <div className="absolute bottom-4 left-4 right-4 flex flex-col gap-2">
                  <h3 className="text-lg lg:text-3xl font-semibold text-[#f9f9f9]">
                    Speakers
                  </h3>
                  <p className="text-sm text-[#f9f9f9]">
                    Amazon wireless speakers
                  </p>
                  <div className="flex flex-col gap-1">
                    <Link 
                      href="/speakers" 
                      className="text-base font-semibold text-white hover:opacity-80 transition-opacity"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel=""
                      onClick={() => {}}
                      aria-label="Shop Speakers"
                    >
                      Shop Now
                    </Link>
                    <img 
                      src="/images/img_underline.svg" 
                      alt="" 
                      className="w-[80px] h-[1px]"
                    />
                  </div>
                </div>
              </div>

              {/* Perfume */}
              <div className="flex-1 bg-black rounded-lg p-4 lg:p-6 min-h-[200px] lg:min-h-[284px] relative">
                {/* Background Circle */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[238px] h-[238px] bg-[#d9d9d9e5] rounded-full shadow-[0px_4px_300px_#888888ff] opacity-50"></div>
                
                {/* Perfume Image */}
                <div className="absolute top-4 left-1/2 transform -translate-x-1/2">
                  <img
                    src="/images/img_652e82cd70aa652.png"
                    alt="GUCCI INTENSE OUD EDP Perfume"
                    className="w-[150px] lg:w-[200px] h-auto object-contain"
                    loading="lazy"
                  />
                </div>

                {/* Content */}
                <div className="absolute bottom-4 left-4 right-4 flex flex-col gap-2">
                  <h3 className="text-lg lg:text-3xl font-semibold text-[#f9f9f9]">
                    Perfume
                  </h3>
                  <p className="text-sm text-[#f9f9f9]">
                    GUCCI INTENSE OUD EDP
                  </p>
                  <div className="flex flex-col gap-1">
                    <Link 
                      href="/perfume" 
                      className="text-base font-semibold text-white hover:opacity-80 transition-opacity"
                      variant="default"
                      size="medium"
                      target="_self"
                      rel=""
                      onClick={() => {}}
                      aria-label="Shop Perfume"
                    >
                      Shop Now
                    </Link>
                    <img 
                      src="/images/img_underline.svg" 
                      alt="" 
                      className="w-[80px] h-[1px]"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewArrivals;